var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Error',{staticClass:"error",attrs:{"code":404,"message":"Page Not Found"}})
}
var staticRenderFns = []

export { render, staticRenderFns }